module.exports = __webpack_public_path__ + "img/hr-stone-path-1.7c748ec6.png";